export default {
  en: {
    title: "Knowledge",
    subtitle: "Groups of documents your agents can search. Add documents, then try a search to see what an agent would find.",
    collections: {
      title: "Collections",
      list: "Knowledge collections",
      none: "No collections yet.",
      new: "New collection",
      createTitle: "New knowledge collection",
      name: "Name",
      nameHelp: "Lower-case letters, digits, '-' and '_' (up to 63 characters).",
      description: "Description",
      classification: "Classification ceiling",
      embedding: "Model choice for search",
      dimension: "Embedding dimension",
      create: "Create",
      cancel: "Cancel",
      created: "Collection {{name}} created",
      select: "Choose a collection",
      selectHint: "Choose a collection to see its documents and test search.",
      meta: "{{classification}} · {{embedding}}",
    },
    classification: { public: "Public", internal: "Internal", confidential: "Confidential", restricted: "Restricted" },
    curated: {
      label: "Curated by us (trusted)",
      help: "Your knowledge admins keep this collection, so agents treat what they find here as the organisation's own rules. A change an agent makes after reading it does not need an approver for that reason alone. Turn this off for a collection filled from outside (documents people send, e-mails, web pages). Web pages and e-mails in a curated collection still count as outside content.",
      on: "Curated by us",
      off: "From outside",
      saved: "Saved",
      failed: "Could not save the setting",
    },
    docs: {
      title: "Documents",
      curatorOnly: "Only knowledge curators can see and change the documents of a collection.",
      add: "Add document",
      addTitle: "Add a document to {{collection}}",
      colTitle: "Title",
      source: "Source URI",
      language: "Language",
      version: "Version",
      chunks: "Chunks",
      ingested: "Added",
      state: "State",
      stale: "Stale",
      deleted: "Deleted",
      current: "Current",
      actions: "Actions",
      none: "No documents in this collection.",
      delete: "Delete document {{title}}",
      deleteConfirm: "Remove this document from the collection? Its history is kept.",
      removed: "Document removed",
      fieldTitle: "Title",
      fieldUri: "Source URI",
      fieldVersion: "Version",
      fieldLanguage: "Language",
      fieldClassification: "Classification",
      public: "Visible to everyone in the organisation",
      groups: "Groups (comma separated)",
      text: "Text",
      file: "Load text from a file (.txt, .md)",
      save: "Ingest",
      cancel: "Cancel",
      result: { created: "Document ingested: {{chunks}} chunks", updated: "New version ingested: {{chunks}} chunks", unchanged: "Unchanged: this version is already ingested" },
      lang: { ar: "Arabic", en: "English" },
    },
    search: {
      title: "Try a search",
      query: "Question or keywords",
      run: "Search",
      none: "Nothing in these documents matches.",
      results: "Results",
      score: "Match {{score}}",
    },
    issues: {
      name_invalid: "The name must start with a lower-case letter or digit and use only a-z, 0-9, '-' and '_'.",
      embedding_required: "Choose a model choice for search.",
      dimension_invalid: "The dimension must be between 2 and 4096.",
      title_required: "Enter a title.",
      uri_required: "Enter a source URI.",
      version_required: "Enter a version.",
      text_required: "Enter the document text.",
    },
  },
  ar: {
    title: "المعرفة",
    subtitle: "مجموعات مستندات يستطيع وكلاؤك البحث فيها. أضف المستندات ثم جرّب البحث لترى ما سيجده الوكيل.",
    collections: {
      title: "المجموعات",
      list: "مجموعات المعرفة",
      none: "لا توجد مجموعات بعد.",
      new: "مجموعة جديدة",
      createTitle: "مجموعة معرفة جديدة",
      name: "الاسم",
      nameHelp: "حروف لاتينية صغيرة وأرقام و'-' و'_' (حتى ٦٣ حرفًا).",
      description: "الوصف",
      classification: "سقف التصنيف",
      embedding: "اسم نموذج التضمين",
      dimension: "بُعد التضمين",
      create: "إنشاء",
      cancel: "إلغاء",
      created: "تم إنشاء المجموعة {{name}}",
      select: "اختر مجموعة",
      selectHint: "اختر مجموعة لعرض مستنداتها واختبار البحث.",
      meta: "{{classification}} · {{embedding}}",
    },
    classification: { public: "عام", internal: "داخلي", confidential: "سري", restricted: "مقيّد" },
    curated: {
      label: "منسّقة من قبلنا (موثوقة)",
      help: "يتولى مسؤولو المعرفة لديكم هذه المجموعة، لذا تعامل الوكلاء ما يجدونه فيها على أنه قواعد المؤسسة نفسها. لا يحتاج تغيير يجريه الوكيل بعد قراءتها إلى معتمِد لهذا السبب وحده. أوقف هذا الخيار لمجموعة تُملأ من الخارج (مستندات يرسلها الناس أو رسائل بريد أو صفحات ويب). تبقى صفحات الويب والرسائل في مجموعة منسّقة محتوى خارجيًا.",
      on: "منسّقة من قبلنا",
      off: "من الخارج",
      saved: "تم الحفظ",
      failed: "تعذّر حفظ الإعداد",
    },
    docs: {
      title: "المستندات",
      curatorOnly: "يمكن لأمناء المعرفة فقط عرض مستندات المجموعة وتعديلها.",
      add: "إضافة مستند",
      addTitle: "إضافة مستند إلى {{collection}}",
      colTitle: "العنوان",
      source: "معرّف المصدر",
      language: "اللغة",
      version: "الإصدار",
      chunks: "المقاطع",
      ingested: "تاريخ الإضافة",
      state: "الحالة",
      stale: "منتهي الصلاحية",
      deleted: "محذوف",
      current: "حالي",
      actions: "الإجراءات",
      none: "لا توجد مستندات في هذه المجموعة.",
      delete: "حذف المستند {{title}}",
      deleteConfirm: "هل تريد إزالة هذا المستند من المجموعة؟ يُحتفظ بسجله.",
      removed: "تمت إزالة المستند",
      fieldTitle: "العنوان",
      fieldUri: "معرّف المصدر",
      fieldVersion: "الإصدار",
      fieldLanguage: "اللغة",
      fieldClassification: "التصنيف",
      public: "مرئي لجميع مستخدمي الجهة",
      groups: "المجموعات (مفصولة بفواصل)",
      text: "النص",
      file: "تحميل النص من ملف (‎.txt أو ‎.md)",
      save: "استيعاب",
      cancel: "إلغاء",
      result: { created: "تم استيعاب المستند: {{chunks}} مقطع", updated: "تم استيعاب إصدار جديد: {{chunks}} مقطع", unchanged: "بلا تغيير: هذا الإصدار مستوعب مسبقًا" },
      lang: { ar: "العربية", en: "الإنجليزية" },
    },
    search: {
      title: "اختبار البحث",
      query: "سؤال أو كلمات مفتاحية",
      run: "بحث",
      none: "لا يوجد في هذه المستندات ما يطابق.",
      results: "النتائج",
      score: "التطابق {{score}}",
    },
    issues: {
      name_invalid: "يجب أن يبدأ الاسم بحرف لاتيني صغير أو رقم وأن يقتصر على a-z و0-9 و'-' و'_'.",
      embedding_required: "اختر اسم نموذج التضمين.",
      dimension_invalid: "يجب أن يكون البعد بين ٢ و٤٠٩٦.",
      title_required: "أدخل عنوانًا.",
      uri_required: "أدخل معرّف المصدر.",
      version_required: "أدخل الإصدار.",
      text_required: "أدخل نص المستند.",
    },
  },
};
